import { Box, Flex, Text } from '@chakra-ui/react';
import { useAddress } from '@thirdweb-dev/react';
import React, { useMemo, useState } from 'react';

import { Search } from '@app/components/Search';
import { usePositionsListData } from '@app/hooks/positions/usePositionsListData';
import { ListLoader } from '@app/screens/pools/components/ListLoader';
import { PositionsListRow } from '@app/screens/positions/components/PositionsListRow/PositionsListRow';

import s from './PositionsList.module.scss';
import { CreatePositionButton } from '@app/screens/positions/components/CreatePositionButton';
import { usePairsDayData } from '@app/hooks/pair/usePairsDayData';
import { useHideOnUnmount } from '@app/hooks/other/useHideOnUnmount';

const ITEMS_PER_PAGE = 100;

export const PositionsList = () => {
  const address = useAddress();
  const [searchTerm, setSearchTerm] = useState('');

  const { data, isLoading } = usePositionsListData({
    skip: 0,
    first: ITEMS_PER_PAGE,
    address: address ? address.toLowerCase() : ''
  });

  const ids = data
    ? data
        .map(({ pair }) => {
          return `"${pair.id}"`;
        })
        .join(',')
    : undefined;

  const { data: pairsDayData } = usePairsDayData({
    ids
  });

  const filteredData = useMemo(() => {
    if (!data || data.length === 0) {
      return null;
    }

    return data.filter(item => {
      if (!searchTerm) {
        return true;
      }

      const {
        pair: { token0, token1 }
      } = item;

      const value = searchTerm.toLowerCase();

      return (
        token0.symbol.toLowerCase().includes(value) ||
        token0.name.toLowerCase().includes(value) ||
        token1.symbol.toLowerCase().includes(value) ||
        token1.name.toLowerCase().includes(value)
      );
    });
  }, [data, searchTerm]);

  function renderList() {
    if (isLoading) {
      return <ListLoader />;
    }

    if (!filteredData || filteredData.length === 0) {
      return (
        <Flex minHeight="300px" width="100%" align="center" justify="center">
          <Text color="neutral.400" fontSize="32px">
            No data found
          </Text>
        </Flex>
      );
    }

    return (
      <>
        {filteredData?.map(item => {
          const dayData = pairsDayData?.filter(
            p => p.pairAddress === item.pair.id
          );

          return (
            <PositionsListRow key={item.id} item={item} dayData={dayData} />
          );
        })}
      </>
    );
  }

  const { display } = useHideOnUnmount();

  if (!display) {
    return null;
  }

  return (
    <Box
      p={['12px', '28px']}
      borderRadius="16px"
      bg="gray.3"
      border="1px solid"
      borderColor="whiteOpacity.6"
    >
      <Box className={s.container}>
        <Box gap="12px" className={s.topWrapper}>
          <Search onSearch={val => setSearchTerm(val)} />
          <CreatePositionButton />
        </Box>
        <div className={s.header}>
          <Flex width="30%">Pool</Flex>
          <Flex width="10%">Amount</Flex>
          <Flex width="10%">Composition</Flex>
          <Flex width="15%">Fees APR</Flex>
          <Flex width="10%">Pool share</Flex>
          <Flex width="25%">&nbsp;</Flex>
          <Flex width="10%">&nbsp;</Flex>
        </div>
        {renderList()}
      </Box>
    </Box>
  );
};
